import { indexData } from '@/mocks/home-data';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">主题索引</h2>
          <p className="text-sm text-foreground-600">七大内容板块 · 吃瓜一网打尽</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.slice(0, 4).map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {indexData.slice(4).map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}